export default __webpack_public_path__ + "static/media/bg3.321a7659.png";